import { Navigate, Outlet, useParams, useOutletContext } from "react-router-dom";
import { supabase } from "../../supabaseClient";
import { useEffect, useState } from "react";
import AccountOnHold from "./Accountonhold";

export default function VendorEventOnboardingGuard() {
  const { eventKey } = useParams();
  const outletContext = useOutletContext(); // { vendor, setVendor } from VendorLayout

  const [status, setStatus] = useState("loading");
  // "loading" | "not_logged_in" | "on_hold" | "not_found" | "not_accepted" | "allowed"

  useEffect(() => {
    let cancelled = false;

    const check = async () => {
      try {
        const { data: { user } } = await supabase.auth.getUser();
        if (!user) { if (!cancelled) setStatus("not_logged_in"); return; }

        const { data: vendor, error: vendorError } = await supabase
          .from("vendors")
          .select("id")
          .eq("user_id", user.id)
          .single();

        if (vendorError || !vendor) { if (!cancelled) setStatus("not_found"); return; }

        // eventKey in the URL may be an event_key or a raw event id —
        // same lookup pattern used in VendorEventWorkspace.
        const { data: event, error: eventError } = await supabase
          .from("events")
          .select("id")
          .or(`event_key.eq.${eventKey},id.eq.${eventKey}`)
          .maybeSingle();

        if (eventError || !event) { if (!cancelled) setStatus("not_found"); return; }

        const { data: application, error: appError } = await supabase
          .from("vendor_applications")
          .select("status, onboarding_completed")
          .eq("vendor_id", vendor.id)
          .eq("event_id", event.id)
          .maybeSingle();

        if (appError) { if (!cancelled) setStatus("not_found"); return; }

        if (application?.status === "on_hold") { if (!cancelled) setStatus("on_hold"); return; }

        const isAccepted = ["approved", "accepted"].includes(String(application?.status).toLowerCase());
        if (!application || !isAccepted) { if (!cancelled) setStatus("not_accepted"); return; }

        // Accepted — let them into the workspace regardless of
        // onboarding_completed. The workspace itself renders whichever
        // step comes next; this guard only decides who gets in at all.
        if (!cancelled) setStatus("allowed");
      } catch (err) {
        console.error("Event onboarding guard error:", err);
        if (!cancelled) setStatus("not_found");
      }
    };

    check();
    return () => { cancelled = true; };
  }, [eventKey]);

  if (status === "loading")       return <p>Loading...</p>;
  if (status === "not_logged_in") return <Navigate to="/vendor/login" replace />;
  if (status === "on_hold")       return <AccountOnHold />;
  if (status === "not_found")     return <Navigate to="/vendor/events" replace />;
  if (status === "not_accepted")  return <Navigate to="/vendor/events" replace />;

  return <Outlet context={outletContext} />;
}